import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MaterialModal from "../MaterialModal";

import * as fileImportActions from "../../../actions/fileImportActions";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../actions/actionCreators";
import * as dashboardWidgetActions from "../../../actions/dashboardWidgetActions";

class DataDashboardDeleteFileModal extends React.Component {
    hide = () => this.props.hideModal("FILE_DELETE_DATADASHBOARD");

    delete = () => {
        const { modalProps, companyId, deleteImport, clearDataDashboardRow } = this.props;
        modalProps.tableKey != null
            ? deleteImport(modalProps.tableKey, companyId, true)
            : clearDataDashboardRow(modalProps.fileId);
        this.props.hideModal("FILE_DELETE_DATADASHBOARD");
    };

    render() {
        const { isOpen, modalProps } = this.props;

        let modalText = "";
        modalProps.tableKey != null
            ? (modalText = (
                  <div>
                      Deleting this table affects all places where it was used, such as flows and calculated fields,
                      etc.
                      <br />
                      <strong>This action is irreversible.</strong>
                  </div>
              ))
            : (modalText = (
                  <div>
                      This will clear the current errored row.
                      <br />
                      <strong>This action is irreversible.</strong>
                  </div>
              ));

        const modal = (
            <MaterialModal
                title={modalProps.tableKey != null ? "Delete File" : "Clear Row"}
                isOpen={isOpen}
                onClose={this.hide}
                id="flow-delete"
                maxWidth="lg"
                primaryButtonText={modalProps.tableKey != null ? "Delete" : "Clear"}
                onPrimaryButtonRequest={this.delete}
                disableEnforceFocus
            >
                {modalText}
            </MaterialModal>
        );
        return modal;
    }
}

DataDashboardDeleteFileModal.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func.isRequired,
    companyId: PropTypes.number,
    getTableTablesForDeletion: PropTypes.func,
    getFileMasterLog: PropTypes.func,
    deleteImport: PropTypes.func,
    clearDataDashboardRow: PropTypes.func,
};

const mapStateToProps = state => ({
    companyId: state.session.companyId,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(Object.assign({}, actionCreators, fileImportActions, dashboardWidgetActions), dispatch);
const DataDashboardDeleteFileModalConnected = connect(
    mapStateToProps,
    mapDispatchToProps
)(DataDashboardDeleteFileModal);

import withModal from "../withModal";
const DataDashboardDeleteFileModalConnected2 = withModal(
    DataDashboardDeleteFileModalConnected,
    "FILE_DELETE_DATADASHBOARD"
);

export default DataDashboardDeleteFileModalConnected2;
